import { reviewerId, isWaived, isClosedStatus, trimmedNote } from './taskTree';
import { TaskStatus } from './taskWorkflow';

const TODO_STATUSES = new Set([
  TaskStatus.PLANNED,
  TaskStatus.IN_PROGRESS,
  TaskStatus.WAITING_ON_EXTERNAL,
  TaskStatus.BLOCKED
]);

const DETAIL_BASE = {
  operations: '/builder/operations/managementTasks',
  sales: '/builder/sales/managementTasks',
  inventory: '/builder/inventory/managementTasks'
};

export function managementTaskDetailPath(vertical, taskId) {
  const base = DETAIL_BASE[vertical] || DETAIL_BASE.operations;
  return `${base}/${taskId}`;
}

function isReturnedToComplete(subtask) {
  return TODO_STATUSES.has(subtask?.status) && !!trimmedNote(subtask?.returnReason);
}

function groupByTask(rows, { splitReturned = false } = {}) {
  const byId = new Map();
  for (const row of rows) {
    const key = splitReturned ? `${row.taskId}:${row.returned ? '1' : '0'}` : String(row.taskId);
    const existing = byId.get(key);
    if (existing) {
      existing.count += 1;
    } else {
      byId.set(key, { ...row, count: 1 });
    }
  }
  return [...byId.values()];
}

export function splitMineManagementWork(tasks, userId) {
  const me = String(userId || '');
  const toDo = [];
  const toApprove = [];

  for (const task of tasks || []) {
    const children = Array.isArray(task.subTask) ? task.subTask : [];
    for (const subtask of children) {
      if (isWaived(subtask) || isClosedStatus(subtask.status)) continue;
      const card = {
        taskId: task.id,
        title: task.title || 'Management Task',
        projectName: task.project?.name || '',
        projectId: task.project_id,
        returned: false
      };
      if (String(subtask.assignedTo_id || '') === me && TODO_STATUSES.has(subtask.status)) {
        toDo.push({ ...card, returned: isReturnedToComplete(subtask) });
      }
      if (
        String(reviewerId(task, subtask) || '') === me &&
        subtask.status === TaskStatus.UNDER_REVIEW
      ) {
        toApprove.push(card);
      }
    }
  }

  return {
    toDo: groupByTask(toDo, { splitReturned: true }),
    toApprove: groupByTask(toApprove)
  };
}
